import axios from 'axios';

axios.defaults.withCredentials = true;

export async function getUsers() {
  try {
    const response = await axios.get(`${import.meta.env.VITE_APP_API_URL}get-users`);

    return response

  } catch (error) {
    console.error('Error al obtener los usuarios', error);
  }
}